/** Primary OK button on “Cancel subscription” confirmation modals. */
export const SUBSCRIPTION_CANCEL_MODAL_OK_BUTTON_STYLE = {
  backgroundColor: "#222222",
  borderColor: "#222222",
  color: "#FFFFFF",
} as const;
